import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37190fe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "consent-title" }, "Please confirm compliance with Data Protection Regulations", -1))
const _hoisted_2 = { class: "consent-info-box" }
const _hoisted_3 = { class: "consent-form-checkbox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "I Confirm", -1))
const _hoisted_5 = { class: "consent-info-box" }
const _hoisted_6 = { class: "consent-form-checkbox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "I Confirm", -1))

import { DxValidator } from "devextreme-vue";
import { DxRequiredRule } from "devextreme-vue/validator";
import { DxCheckBox } from "devextreme-vue/check-box";
import { computed, PropType, ref } from "vue";
import scrollView from "@/components/ui/scroll-view.vue";
import { LandlordSwitchConsent } from "@/types/switches/LandlordSwitchConsent";


export default /*#__PURE__*/_defineComponent({
  __name: 'landlord-consent-page',
  props: {
  /**
   * The object representing landlord switch consent data.
   * Used with `v-model` to track and update consent-related information.
   * @type {LandlordSwitchConsent}
   * @required
   */
  modelValue: {
    type: Object as PropType<LandlordSwitchConsent>,
    required: true,
  },

  /**
   * The validation group name used for form validation.
   * Helps in grouping form fields for validation purposes.
   * @type {string}
   * @required
   */
  validationGroup: {
    type: String,
    required: true,
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, usually triggered by a change in the filters.
   * @event update:modelValue
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const consentOptions = computed({
  get: () => props.modelValue,
  set: (value: LandlordSwitchConsent) => emit("update:modelValue", value),
});

const screenWidth = ref(screen.width);

const smallScreen = computed(() => screenWidth.value < 769);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["consent-page", { smallScreen: smallScreen.value }])
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" In submitting this form, I confirm that any personal data is being shared with Property Button in compliance with Irish data protection regulations and that, where necessary, the consent of the person(s) involved has been secured. I further confirm that Property Button can share this data with utility and other service providers and that, where necessary, consent for this further transfer has been secured. "),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(DxCheckBox), {
              value: consentOptions.value.personalDataConsent
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxValidator), {
                  "validation-group": props.validationGroup
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxRequiredRule))
                  ]),
                  _: 1
                }, 8, ["validation-group"])
              ]),
              _: 1
            }, 8, ["value"]),
            _hoisted_4
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(" By proceeding, you confirm that you (or the property owner) have provided explicit consent for Property Button to set up a time-of-use energy tariff, which may involve the collection and sharing of 30-minute interval electricity usage data from ESB Networks to the selected energy provider. You understand this data will be used for billing and tariff management purposes and that this consent can be withdrawn at any time. "),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(DxCheckBox), {
              value: consentOptions.value.energyUsageConsent
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxValidator), {
                  "validation-group": props.validationGroup
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxRequiredRule))
                  ]),
                  _: 1
                }, 8, ["validation-group"])
              ]),
              _: 1
            }, 8, ["value"]),
            _hoisted_7
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})